import type { OAuthStatusResponse } from '@firestore-gui/shared';

/** Whether the connection banner should be shown (not connected, status known). */
export function shouldShowBanner(oauthStatus: OAuthStatusResponse | null): boolean {
  if (!oauthStatus) return false;
  return oauthStatus.status !== 'connected';
}

export interface OAuthErrorToast {
  show: boolean;
  title: string;
  description: string;
}

/** Map OAuth error response to a user-facing toast (or skip if popup closed). */
export function getOAuthErrorToast(errorResponse: unknown): OAuthErrorToast {
  const errorCode =
    typeof errorResponse === 'object' && errorResponse !== null && 'error' in errorResponse
      ? String((errorResponse as { error: unknown }).error)
      : String(errorResponse);

  if (errorCode === 'popup_closed_by_user') {
    return { show: false, title: '', description: '' };
  }

  const errorDescription =
    typeof errorResponse === 'object' &&
    errorResponse !== null &&
    'error_description' in errorResponse
      ? (errorResponse as { error_description: unknown }).error_description
      : null;
  const description =
    typeof errorDescription === 'string'
      ? errorDescription
      : 'Google Cloud connection was cancelled or failed.';

  return {
    show: true,
    title: 'Connection Failed',
    description,
  };
}
